import ErrorMessage from 'utils/ErrorMessage'
import { systemConfig } from 'utils/config.js'
import corporateRequest from 'utils/corporateRequest'
import elasticSearchRequest from 'utils/elasticSearchRequest'
import instRequest from 'utils/instRequest'
import studentRequest from 'utils/studentRequest'
export const getJobRoleList =
  ({ instituteCampusId, data }) =>
    async () => {
      return new Promise(async resolve => {
        try {
          const response = await corporateRequest.post(
            `/corporates/instiuteCampus/${instituteCampusId}/jobs`,
            data
          )

          resolve(response?.data?.data)
        } catch (error) {
          resolve(false)
        }
      })
    }

export const exportCandidate =
  (roleId, key, payload) => async (dispatch, getState) => {
    try {
      const config = key !== 'googlesheet' ? { responseType: 'blob' } : {}

      const response = await studentRequest.put(
        `/students/role/${roleId}/candidate/${key}/export`,
        payload,
        config
      )
      return response?.data
    } catch (err) {
      console.error('API Error:', err)
      ErrorMessage('Error fetching roles, Try again.')
      throw err
    }
  }

export const getExportFiledData = () => async (dispatch, getState) => {
  try {
    const response = await studentRequest.get(
      `/students/institutes/heading/export`
    )
    return response?.data?.data
  } catch (error) {
    ErrorMessage('Error fetching roles, Try again .')
  }
}
export const getCorporateData =
  (corporate_Id, instituteCampusId) => async (dispatch, getState) => {
    try {
      const response = await corporateRequest.get(
        `/corporates/${corporate_Id}?instituteCampusId=${instituteCampusId ?? ''
        }`
      )
      return response?.data?.data
    } catch (error) {
      ErrorMessage('Error fetching roles, Try again .')
    }
  }
export const getInstituteData =
  (instituteCampusId, instituteCompanyId) => async (dispatch, getState) => {
    try {
      const response = await corporateRequest.get(
        `/corporate/institute/${instituteCampusId}/company/${instituteCompanyId}`
      )
      return response?.data?.data
    } catch (error) {
      ErrorMessage('Error fetching roles, Try again .')
    }
  }

export const getDegreeList =
  (domainIds, campusId, category, search = '') =>
    async (dispatch, getState) => {
      try {
        let jobCategory = category ? `&jobCategory=${category}` : ''

        const response = await instRequest.get(
          `institutes/${campusId}/degree?domainId=${domainIds}${jobCategory}&search=${search}`
        )
        const data = response?.data?.data || []
        return data
      } catch (err) {
        ErrorMessage('Error fetching roles, Try again .')
      }
    }

export const getDepartmentList =
  (campusId, payload, category) => async (dispatch, getState) => {
    try {
      const response = await instRequest.post(
        `institutes/${campusId}/streams`,
        payload
      )
      const data = response?.data?.data || []
      return data
    } catch (err) {
      ErrorMessage('Error fetching roles, Try again .')
    }
  }

export const getDomainList =
  (campusId, category, search = '') =>
    async (dispatch, getState) => {
      try {
        let jobCategory = category ? `&jobCategory=${category}` : ''
        const response = await instRequest.get(
          `institutes/${campusId}/domain?${jobCategory}&search=${search}`
        )
        const data = response?.data?.data || []
        return data
      } catch (err) {
        ErrorMessage('Error fetching roles, Try again .')
      }
    }

export const getStatusFilter =
  (instituteCampusId, jobCategory) => async (dispatch, getState) => {
    try {
      const result = await corporateRequest.get(
        `/corporates/filterStatus/instituteCampus/${instituteCampusId}/jobs?jobCategory=${jobCategory}`
      )
      return result?.data?.data
    } catch (error) {
      ErrorMessage(error?.message)
    }
  }

export const getRoleFilter =
  (instituteCampusId, jobCategory) => async (dispatch, getState) => {
    try {
      const result = await corporateRequest.get(
        `/corporates/filterRole/instituteCampus/${instituteCampusId}/jobs?jobCategory=${jobCategory}`
      )
      return result?.data?.data
    } catch (error) {
      ErrorMessage(error?.message)
    }
  }

export const getScheduleFilter =
  (instituteCampusId, jobCategory) => async (dispatch, getState) => {
    try {
      const result = await corporateRequest.get(
        `/corporates/filterEvaluation/instituteCampus/${instituteCampusId}/jobs?jobCategory=${jobCategory}`
      )
      return result?.data?.data
    } catch (error) {
      ErrorMessage(error?.message)
    }
  }

export const getYear = instituteCampusId => async (dispatch, getState) => {
  try {
    const result = await studentRequest.get(
      `/students/institutes/${instituteCampusId}/yearOfPassing`
    )
    return result?.data?.data
  } catch (error) {
    ErrorMessage(error?.message)
  }
}

export const getEligibilityCriteriaQualification =
  ({ searchValue, searchType = 'ALL', searchField, callEndPoint }) =>
    async (dispatch, getState) => {
      let filters = [
        {
          field: 'type.keyword',
          value: searchField,
        },
        {
          field: 'status.keyword',
          value: '1',
        },
      ]
      let diplomaFilters = [
        {
          field: 'status.keyword',
          value: '1',
        },
      ]
      let addAbout = [
        {
          field: 'type.keyword',
          value: 'DIPLOMA',
        },
        {
          field: 'type.keyword',
          value: 'P_G_DIPLOMA',
        },
      ]
      if (
        (searchValue && searchType == 'STREAM') ||
        searchType == 'SPECIALISATION'
      ) {
        searchValue = searchValue.toLowerCase()
      }
      let payLoad = systemConfig?.degree_streams_specialisation
      payLoad.q = searchValue || ''
      payLoad.searchType = searchType
      payLoad.filters = searchField == 'DIPLOMA' ? diplomaFilters : filters
      payLoad.should = searchField == 'DIPLOMA' ? addAbout : []
      try {
        const endpoint = `/search/degrees/streams/specialisations${callEndPoint ? '/events' : ''
          }`
        const result = await elasticSearchRequest.post(endpoint, payLoad)

        return result?.data?.data
      } catch (error) {
        ErrorMessage(error?.message)
      }
    }

export const exportCSV =
  (instituteCampusId, payload, type) => async (dispatch, getState) => {
    try {
      const domain =
        payload.domainId !== '' ? `&domainId=${payload.domainId}` : ''
      const degree =
        payload.degreeId !== '' ? `&degreeId=${payload.degreeId}` : ''
      const streamId =
        payload.streamId !== '' ? `&streamId=${payload.streamId}` : ''
      const jobCategory =
        payload.jobCategory !== '' ? `?jobCategory=${payload.jobCategory}` : ''
      const year =
        payload.yearOfPassing !== ''
          ? `&yearOfPassing=${payload.yearOfPassing}`
          : ''
      const degreeeType =
        payload.degreeType !== '' ? `&degreeType=${payload.degreeType}` : ''
      const config = type !== 'googlesheet' ? { responseType: 'blob' } : {}

      const result = await corporateRequest.get(
        `corporates/instituteCampus/${instituteCampusId}/export/${type}${jobCategory}${domain}${degree}${streamId}${year}${degreeeType}`,
        config
      )
      return result?.data
    } catch (error) {
      ErrorMessage(error?.message)
    }
  }

export const duplicateRole =
  (jobId, corporate_id, instituteCampusId) => async (dispatch, getState) => {
    try {
      const result = await corporateRequest.post(
        `/corporates/${corporate_id}/jobs/${jobId}/duplicate`,
        {
          instituteCampusId,
          yearOfPassing: undefined
        }
      )
      return result
    } catch (error) {
      ErrorMessage(error?.message)
    }
  }
